// import css from "./info.module.css";
// import srvd from "../../img/aboutPic.png";
// import kuharchuk from "../../img/kuharchuk.jpg";
// import tkach from "../../img/tkach.jpg";
// import sumonenco from "../../img/sumonenco.jpg";
// import viberForConractO from "../../img/viberForConractO.png";
// import newTgK from "../../img/newTgK.png";
// import ptahToContact from "../../img/ptahToContact.png";
// import phptoForAG from "../../img/phptoForAG.PNG";
// import milaradchenko from "../../img/milaradchenko.jpg";
// export default function AboutComp() {
//   return (
//     <div className={css.aboutWrapAll}>
//       <div className={css.smallWrapAbout}>
//         <div className={css.wrapTwoButtonNew}>
//           {" "}
//           <a className={css.inContactButtin} href="#section1">
//             Про видавництво
//           </a>{" "}
//           <a className={css.inContactButtin} href="#section2">
//             Маніфест видавця
//           </a>{" "}
//           <a className={css.inContactButtin} href="#section3">
//             Казка про Час майстрів
//           </a>{" "}
//           <a className={css.inContactButtin} href="#section4">
//             Колектив
//           </a>{" "}
//           <a className={css.inContactButtin} href="#section5">
//             Контакти
//           </a>{" "}
//           <a className={css.inContactButtin} href="#section6">
//             Вакансії
//           </a>{" "}
//         </div>
//         <div id="section1" className={css.buttonGrenDostavka}>
//           Про видавництво
//         </div>
//         <p className={css.dogovirPd}>Дуже коротко - ми топимо за еволюцію. </p>
//         <p className={css.paragInWrapBig}>
//           Далі довше… Видавництво Час Майстрів представлено на ринку дитячої
//           літератури України вже понад 16 років. Але понад 20 років потому ми
//           вже стрясали ринок навчальної літератури своїми книжковими ноу-хау.
//           Дитяча література почалася з народженням першої донечки засновника,
//           Симоненко Олега. “Я подився на наявні дитячі книги і побачив, що мені
//           не вистачає де-яких книг для створення середовища росту моєї дитини.
//           Створюючі для свої дітей сподіваюсь на те, що це комусь теж стане в
//           нагоді”, - Симоненко Олег. До речі, саме Тих книг ми ще не створили.
//           Все тягнемося до них і вчимося їх створювати. Кожна нова книга
//           наближає нас до нашої мети. Видавництво «Час майстрів» прагне
//           створювати інноваційні книги, які допомагають дітям еволюціонувати.
//           Книги, від яких дітям важко відірватися, є для нас необхідною, але
//           недостатньою умовою. Створювати книги, що ґрунтуються на ноу-хау – це
//           те, що ми любимо робити. Працюємо над створенням художньої літератури,
//           енциклопедій. І ми вже почали працювати над навчальною книгою та
//           нон-фікшн. Маємо на меті випуск лише високоякісних книжок, як витворів
//           мистецтва, для читачів більш ніж одного покоління, рідна мова яких не
//           тільки українська. Наша місія - допомогти батькам вивести дітей на
//           шлях Майстра. Майстри використовують розум, щоб наповнити життя
//           добром, світом і святом. Для цього ми створюємо книжки, які розгортаєш
//           — смакуєш, читаєш — не можеш відірватися, а закриваєш, збагатившись.
//           Ілон Маск згадує, що читав всі книги, до котрих міг дотягнутися
//           руками. Для створення таких книг ми шукаємо Майстрів, що можуть
//           “передати” своє ноу-хау (знаю як) за допомогою книги. Ми сімейне
//           видавництво. Працюємо як одна сім’я.У 2014 році Фредерік Лалу
//           опублікував книгу «Reinventing organizations», в якій виділив декілька
//           стадій розвитку компанії та присвоїв їм відповідні кольори. За нашою
//           оцінкою ми зараз на зеленій стадії розвитку організації. Ми шукаємо
//           спільні цінності, вчимось приймати спільні рішень, розширяти права
//           усіх учасників, спільний контроль і самоконтроль, відкритість,
//           управління за рахунок формування внутрішньої культури праці, вільний
//           графік, віддалений доступ, один за всіх - всі за одного. Плануємо
//           досягти бірюзового рівня - самоорганізація, цілісність, еволюційна
//           мета, холакратія. Видавництво "Час майстрів" експерт з дитячої
//           літератури.
//         </p>
//         <div id="section2" className={css.buttonGrenDostavkaManifest}>
//           Маніфест видавця
//         </div>
//         <p className={css.zagalNotNeedDesc} id="section3">
//           Настав час майстрів. Сьогодні роботи (програми) можуть замінити людину
//           всюди, де виробнича діяльність описується бізнес процессами. Що робити
//           людям? Залишається займатись тим, чого не можуть роботи - творити.
//           Кожна людина здатна на творчість. Кожна творчість корисна для Творця,
//           але не кожна творчість корисна для спільноти. Для неї цінна творчість
//           Майстра Дитина може розвинути в собі майстерність якщо їй цікаво.
//           Треба допогти дитині відкрити в собі цікавість і оволодіти силої. Час
//           руйнувати стереотипи, виходити за межі, створювати небачене. Це
//           завдання для Майстрів. Ілон Маск - майстер. Живе сильно і творить
//           необхідну реальність. Його не замінити роботом. Він може творити не
//           тому, що має гроші, а він має гроші тому що створює необхідне і нове.
//           Книги недостатнє, але необхідне середовище для зростання майстра. У
//           нас є розуміння чому. Про це будемо писати у рамках "Нашої теорії
//           книги" (посилання на блог). Не замінити роботом Малевича, Багряного,
//           Корольова, Сікорського чи Примаченко - це Майстри. Ще раз акцентуємо
//           вашу увагу. Ми видаємо тільке те від чого важко відірватися! Цей
//           критерій для нас необхідний, обов'язковий, але не достатній, бо є
//           велика кількість творів, що тебе захоплює, але особисто ми не вбачаємо
//           сенсу витрачати на них наші сили. Необхідним для на є твір який несе в
//           собі меседж важливий для еволюції, або чи і твір, що міняє стан читач
//           на той, який варто пережити для еволюції. Хоча, по правді сказати, в
//           полеміці можна на кожний твір "натягнути" сенси. Але ми дозволяємо
//           собі за цим питанням не розводити полеміку.
//         </p>
//         <div className={css.buttonGrenDostavkaManifest}>
//           Казка про Час майстів
//         </div>
//         <p className={css.dogovirPd}>
//           Дайте нашим дітям книги — і ви дасте їм крила.
//           <br />
//           Є. Лепман
//         </p>
//         <p className={css.paragInWrapBig} id="section4">
//           Колись, давним-давно, жив собі леґінь, а дехто і дурнем його прозивав
//           — бо відразу не всяк його розпізнати може. Мав він сил і завзяття
//           чимало, та ще й розуму на трьох стало б. Почав він думку гадати, куди
//           б себе подіти. Придивився, бачить — люди все роблять, аби у них усього
//           більше було, тобто все ушир та й ушир ростуть. А леґінь той волів
//           угору рости, бо висота йому більш до вподоби. — От дурник, — казали
//           добрі люди. — Що ти там угорі забув? Від тої висоти ніякого зиску,
//           ушир надійніше буде. — Що ж, нам, дурням, не звикати, — відповів на те
//           леґінь. Щоб комусь допомогти у зріст додати, потрібно вміти й самому
//           рости. — І як його у гору рости? Може, щось з’їсти? — замислився
//           леґінь. Одне з'їв — не виріс. Інше з'їв — у ріст не пішов. Урешті-решт
//           «проковтнув» якось він книжку. Одну з'їсть — росте, іншу — не росте, а
//           від третьої тільки меншає. Хитра загадка, та дурень хитріший! Ясне
//           діло — не від усякої книжки в ріст підеш! Навчився розрізняти. І
//           заходився той хлопець книжки «вирощувати», та все вгору й угору
//           намагається виростити. Непросте завдання. Важко самому з ним
//           впоратися. У такій справі МАЙСТРИ потрібні.— Настав Час Майстрів, —
//           вирішив леґінь. От і став він Майстрів до своєї справи закликати.
//           Отож, люди добрі, той легень знайшов з десяток таких, як він, щоб
//           книжки вирощувати, стали вони товариством — «Час майстрів»
//           називаються. Самі ростуть, і книжки в них підростають. А коли книжки
//           виростуть, то й вони в ріст йдуть. Усе поволі діється, та поспішати
//           нема куди. За кожним словом — образ великий. Знають вони, що слова
//           самі по собі дуже важливі для щастя людей. Та ось біда — з часом люди
//           позабували ті образи. Тому справжня суть зникла з мови, із книжки та
//           із самого життя. Відомо ж, що люди образами мислять. А думки людські
//           спричиняють або щастя, або нещастя… Є образи які приводять людей до
//           вірних думок, що спричиняють щастя. А де які образи викликають
//           страждання. Книжки мають формувати вірні думки у маленьких і великих
//           людей. Хто таку книгу «ковтне», той у ріст і піде. Книжки видавництва
//           «Час майстрів» призначені насамперед для дітей, адже дорослі вже
//           наповнені знаннями. Як кажуть, до повної скрині нічого нового не
//           покладеш. Але коли дорослі дітям читатимуть, може, щось нове через
//           дітей і собі візьмуть.Прийшла пора… Настав «Час майстрів».
//         </p>
//         <div className={css.wrapTwoButtonNew}>
//           {" "}
//           <div className={css.buttonGrenDostavkaManifest}>Колектив </div>{" "}
//           <div id="section5" className={css.buttonGrenDostavkaManifest}>
//             Контакти{" "}
//           </div>
//         </div>
//         {/* <p className={css.zagalNotNeed}>
//           Друзі, наразі наша телефонія не працює стабільно.Будь ласка, пишіть
//           нам через соц. мережі або на електронну пошту для вирішення нагальних
//           питань.
//         </p> */}
//         <div className={css.wrapOneAutor}>
//           <div className={css.wrapPictureTeam}>
//             <img src={kuharchuk} className={css.autorWr} />
//           </div>
//           <div className={css.blockWithInformation}>
//             <p className={css.onlineStoreName}>
//               Завідуюча інтернет-магазином
//               <br />
//               <span className={css.nameAutort}>Леся Кухарчук</span>
//             </p>
//             <p className={css.dataPhone}>
//               <a className={css.dataPhone} href="tel:+380508893545">
//                 +38 (050) 88 93 545
//               </a>
//               <br />
//               <a
//                 className={css.dataPhone}
//                 href="mailto:sales@chasmaistriv.com.ua"
//               >
//                 sales@chasmaistriv.com.ua
//               </a>
//             </p>
//             <div className={css.twoIconSocialWr}>
//               <div className={css.oneIconSocial}>
//                 <p className={css.iconCocialP}>Запитання у вайбер</p>
//                 <div className={css.wrapIvd}>
//                   <a href="viber://chat?number=%2B380508893545">
//                     <img
//                       src={viberForConractO}
//                       className={css.iconInfd}
//                       alt="icon"
//                     />
//                   </a>
//                 </div>
//               </div>
//               <div className={css.oneIconSocial}>
//                 <p className={css.iconCocialP}>Запитання у телеграм</p>

//                 <a href="https://teleg.one/chasmaistriv">
//                   <img src={newTgK} className={css.iconInfd} alt="icon" />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className={css.wrapOneAutor}>
//           <div className={css.wrapPictureTeam}>
//             <img src={tkach} className={css.autorWr} />
//           </div>
//           <div className={css.blockWithInformation}>
//             <p className={css.onlineStoreName}>
//               Відділ реалізації (гуртовий продаж)
//               <br />
//               <span className={css.nameAutort}>Зоряна Ткач</span>
//             </p>
//             <p className={css.dataPhone}>
//               <a className={css.dataPhone} href="tel:+380975043294">
//                 +38 097 504 32 94
//               </a>
//               <br />
//               <a
//                 className={css.dataPhone}
//                 href="mailto:zoryana@chasmaistriv.com.ua"
//               >
//                 zoryana@chasmaistriv.com.ua
//               </a>
//             </p>
//           </div>
//         </div>
//         <div className={css.wrapOneAutor}>
//           <div className={css.wrapPictureTeam}>
//             <img src={sumonenco} className={css.autorWr} />
//           </div>
//           <div className={css.blockWithInformation}>
//             <p className={css.onlineStoreName}>
//               Творець / в.о.головного редактора
//               <br />
//               <span className={css.nameAutort}>Симоненко Олег</span>
//             </p>
//             <p className={css.dataPhone}>
//               <a
//                 className={css.dataPhone}
//                 href="mailto:origin@chasmaistriv.com.ua"
//               >
//                 origin@chasmaistriv.com.ua
//               </a>
//             </p>
//           </div>
//         </div>
//         <div className={css.wrapOneAutor}>
//           <div className={css.wrapPictureTeam}>
//             <img src={phptoForAG} className={css.autorWr} />
//           </div>
//           <div className={css.blockWithInformation}>
//             <p className={css.onlineStoreName}>
//               Директор
//               <br />
//               <span className={css.nameAutort}>Григораш Наталя</span>
//             </p>
//             <p className={css.dataPhone}>
//               <a className={css.dataPhone} href="tel:+380672315696">
//                 +38 068 610 41 89
//               </a>
//               <br />
//               <a
//                 className={css.dataPhone}
//                 href="mailto:glavred@masterclassbook.com"
//               >
//                 glavred@masterclassbook.com
//               </a>
//             </p>
//           </div>
//         </div>
//         <div className={css.wrapOneAutor}>
//           {" "}
//           <div className={css.wrapPictureTeam}>
//             <img src={milaradchenko} className={css.autorWr} />
//           </div>
//           <div className={css.blockWithInformation} id="section6">
//             <p className={css.onlineStoreNameNew}>
//               Відтепер наші видання можна замовити з швидкою доставкою по
//               Європі. <br />
//               <span className={css.nameAutort}>
//                 Офіційній дистриб'ютор ТОВ "Час Майстрів" у ЄС (Польща м.
//                 Краків)
//               </span>
//             </p>
//             <p className={css.dataPhone}>
//               Керівник філії Міла Радченко
//               <br />
//               <a className={css.dataPhone} href="tel:+48790820066">
//                 +48 790 820 066
//               </a>
//               <br />
//               <a
//                 className={css.dataPhone}
//                 href="mailto:mila@chasmaistriv.com.ua"
//               >
//                 mila@chasmaistriv.com.ua
//               </a>
//             </p>
//           </div>
//         </div>{" "}
//         <div className={css.wrapOneAutor}>
//           {" "}
//           <img src={ptahToContact} className={css.autorWrNew} />
//         </div>
//         <div className={css.buttonGrenDostavkaManifest}>Вакансії</div>
//         <p className={css.vacansii}>
//           Видавництво Час Майстрів шукає:
//           <br />
//           <span className={css.bluePSearch}>
//             критиків дитячої літератури на посаду позаштатного співробітника
//             просимо ваше
//           </span>
//           <br />
//           резюме надсилати на емейл{" "}
//           <span className={css.bluePSearch}>
//             <a
//               className={css.bluePSearch}
//               href="mailto:origin@chasmaistriv.com.ua"
//             >
//               origin@chasmaistriv.com.ua
//             </a>
//           </span>
//         </p>
//       </div>
//     </div>
//   );
// }
// src/components/AboutDynamic.jsx
import React from "react";
import css from "./info.module.css";
import { db } from "../../firebase";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import viberForConractO from "../../img/viberForConractO.png";
import newTgK from "../../img/newTgK.png";
const headingClass = (style) =>
  style === "manifest"
    ? css.buttonGrenDostavkaManifest
    : css.buttonGrenDostavka;

// визначаємо, що це саме блок "Вакансії"
const isVacancies = (s) => {
  const title = (s?.title || "").toLowerCase().trim();
  const anchor = (s?.anchor || "").toLowerCase().trim();
  return (
    title === "вакансії" ||
    /ваканс/i.test(title) ||
    anchor === "vacancies" ||
    anchor === "section6" // залишив як запасний варіант, якщо у тебе такий якір
  );
};

export default function AboutDynamic() {
  const [sections, setSections] = React.useState([]);
  const [team, setTeam] = React.useState([]);

  React.useEffect(() => {
    const secQ = query(
      collection(db, "pages", "about", "sections"),
      orderBy("order", "asc")
    );
    const unsubSec = onSnapshot(secQ, (snap) => {
      setSections(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    const teamQ = query(
      collection(db, "pages", "about", "team"),
      orderBy("order", "asc")
    );
    const unsubTeam = onSnapshot(teamQ, (snap) => {
      setTeam(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    return () => {
      unsubSec();
      unsubTeam();
    };
  }, []);

  // готуємо масиви: все крім "Вакансій" + сама секція "Вакансії"
  const vacanciesSection = sections.find(isVacancies);
  const nonVacancySections = sections.filter((s) => !isVacancies(s));

  return (
    <div className={css.aboutWrapAll}>
      <div className={css.smallWrapAbout}>
        {/* Навігація з секцій, де inNav=true (не змінюємо) */}
        <div className={css.wrapTwoButtonNew}>
          {sections
            .filter((s) => s.inNav)
            .map((s) => (
              <a
                key={s.id}
                className={css.inContactButtin}
                href={`#${s.anchor || s.id}`}
              >
                {s.title}
              </a>
            ))}
        </div>

        {/* Спочатку — всі секції, крім "Вакансій" */}
        {nonVacancySections.map((s) => (
          <React.Fragment key={s.id}>
            <div id={s.anchor || s.id} className={headingClass(s.style)}>
              {s.title}
            </div>
            <div
              className={css.paragInWrapBig}
              dangerouslySetInnerHTML={{ __html: s.contentHtml || "" }}
            />
          </React.Fragment>
        ))}

        {/* Потім — Колектив */}
        {team.length > 0 && (
          <>
            {/* якщо у Firestore є окрема секція "Колектив" — цей заголовок можна прибрати */}
            <div id="team" className={headingClass("default")}>
              Колектив
            </div>
            {team.map((p) => (
              <div className={css.wrapOneAutor} key={p.id}>
                <div className={css.wrapPictureTeam}>
                  {p.avatarUrl ? (
                    <img
                      src={p.avatarUrl}
                      className={css.autorWr}
                      alt={p.name}
                    />
                  ) : (
                    <div
                      className={css.autorWr}
                      style={{ background: "#eee" }}
                    />
                  )}
                </div>
                <div className={css.blockWithInformation}>
                  <p className={css.onlineStoreName}>
                    {p.role}
                    <br />
                    <span className={css.nameAutort}>{p.name}</span>
                  </p>
                  <p className={css.dataPhone}>
                    {p.phone && (
                      <>
                        <a className={css.dataPhone} href={`tel:${p.phone}`}>
                          {p.phone}
                        </a>
                        <br />
                      </>
                    )}
                    {p.email && (
                      <a className={css.dataPhone} href={`mailto:${p.email}`}>
                        {p.email}
                      </a>
                    )}
                  </p>

                  {(p.viberUrl || p.telegramUrl) && (
                    <div className={css.twoIconSocialWr}>
                      {p.viberUrl && (
                        <div className={css.oneIconSocial}>
                          <p className={css.iconCocialP}>Запитання у вайбер</p>
                          <div className={css.wrapIvd}>
                            <a href={p.viberUrl}>
                              <img
                                src={viberForConractO}
                                className={css.iconInfd}
                                alt="icon"
                              />
                            </a>
                          </div>
                        </div>
                      )}
                      {p.telegramUrl && (
                        <div className={css.oneIconSocial}>
                          <p className={css.iconCocialP}>
                            Запитання у телеграм
                          </p>
                          <a href={p.telegramUrl}>
                            <img
                              src={newTgK}
                              className={css.iconInfd}
                              alt="icon"
                            />
                          </a>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </>
        )}

        {/* І насамкінець — "Вакансії", якщо є */}
        {vacanciesSection && (
          <>
            <div
              id={vacanciesSection.anchor || vacanciesSection.id}
              className={headingClass(vacanciesSection.style)}
            >
              {vacanciesSection.title}
            </div>
            <div
              className={css.paragInWrapBig}
              dangerouslySetInnerHTML={{
                __html: vacanciesSection.contentHtml || "",
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}
